import {
  AccountType,
  CommonSwitchStatus,
  CurrencyInfos,
  GeetestValidate,
  NormalLoginFormData,
  NormalRegisterRequest,
  SMSLoginReq,
  ThirdWayLoginNewAccountRes,
  ThirdWayLoginReq,
  UserInfos
} from '@/api/common/type'
import { GeeHeaders, TGeetestCaptchaResult, WithGeeGuard } from './GeeTest'
import {
  GlobalConst,
  GlobalEvents,
  GlobalManager,
  GlobalService
} from '@/context'
import { Language, useI18n } from '@/i18n'
import { SystemInfos } from '@/api/common/type'
import {
  apiFastLogin,
  apiGetHomeGold,
  apiLogin,
  apiLoginAfterGeetestValidate,
  apiLoginBeforeGeetestValidate,
  apiLogout,
  apiRegister,
  apiSMSLogin,
  apiThirdWayLogin,
  apiThirdWayRegister
} from '@/api/common'
import { checkPasswordStrength } from '@/utils/PasswordStrength'
import { delay } from '@/utils/Tool'
import { loadScripts } from '@/utils/Loader'
import { merge, pick } from 'lodash'
import { onAppEvent } from '@/utils/business-utils'
import { useActivityChestStore } from '@/views/task/store/activityChest'
import { useGameStore } from '@/views/game/store'
import { useMainStore } from '@/store/index'
// TODO66 标记日期3月3号 弹窗版的任务已经弃用,替换成了页面版的,使用的地方暂时全都注释
// import { useTaskModalStore } from '@/views/global-modal/modal/tasks-modal-dialog/store/task-modal-store'
import { useFirstChargeConstantStore } from '@/views/global-modal/modal/first-charge-constant/store'
import { useTaskModalConstant } from '@/views/global-modal/modal/tasks-modal-dialog/store/task-modal-constant'
import { useTaskPageStore } from '@/views/task/store/taskPageStore'
import { windowConfig } from '@/utils/window'
import Const from '@/context/const'
import Modal from '@/controller/Modal'
import Site from './Site'
import to from 'await-to-js'

export type LoginType =
  | 'normal'
  | 'fastlogin'
  | 'trymode'
  | 'sms'
  | 'thirdlogin'

export default class User {
  public static get createLoginBasePayload() {
    const { osType, uuid } = useMainStore()
    return {
      clientType: 5,
      jpush_id: '',
      loginId: uuid,
      /**
       * 该os_type字段影响后续此用户关联的系统，关联很多后面的如活动此系统是否可以领取等问题
       */
      os_type: (() => {
        if (windowConfig.package.isLite) {
          return windowConfig.speedPackageConfig?.osType
        }
        return osType
      })(),
      /**
       * 新增deviceOsType字段仅仅用于登录注册日志记录使用
       * 极速包环境也需要把登录注册的动作记录为原生类型
       */
      deviceOsType: GlobalService.getDeviceOsType(),
      deviceModel: GlobalService.getDeviceModel(),
      ...Site.getChannelInfo(),
      ...(windowConfig.package.isLite
        ? {
            clientType: 2,
            mtpush_id: windowConfig?.speedPackageConfig?.pushId
          }
        : {}),
      domain: location.origin
    }
  }
  /** 统一上报login 去重处理 */
  private static logSend() {
    if (sessionStorage.getItem('IndicatorB')) {
      return
    }
    sessionStorage.setItem('IndicatorB', 'true')
    onAppEvent('login')
    GlobalEvents.dispatch({
      type: 'MONITOR_EVENT',
      eventName: 'IndicatorB',
      payload: {}
    })
  }
  /**
   * 登出处理
   */
  public static async logout() {
    const { userInfos, updateUserInfos, networkProtect } = useMainStore()
    /**
     * 登出接口发出后，调用暂停其它请求的方法
     */
    setTimeout(() => {
      networkProtect()
    }, 10)

    try {
      GlobalEvents.dispatch({
        type: 'LOGOUT_BEFORE'
      })
      await apiLogout({
        username: String(userInfos?.username)
      })
      GlobalEvents.dispatch({
        type: 'LOGOUT_SUCCESS',
        payload: {
          userInfos: {
            username: userInfos?.username
          }
        }
      })
      onAppEvent('logout')
    } finally {
      updateUserInfos(null)
      // useTaskModalStore()
      //   .myReset()
      //   .then(() => {
      //     useTaskModalStore().freshCodeCateReceive()
      //   })
      // 标记日期3月8号 这两个reset是刻意保留的,不要删除,它们用来在退出时,重置未登录状态的用户弹窗状态
      useTaskModalConstant().myRest()
      useFirstChargeConstantStore().myReset()
      GlobalManager.Page.toRoot()
    }
  }
  /**
   * 登出弹框
   */
  public static async logoutModal() {
    const { t } = useI18n()
    const modal = GlobalManager.Modal.create({
      title: t('lobby.common.tips.title'),
      titlePosition: 'center',
      titleType: 'info',
      class: 'my-modal-base-cancel',
      content: t('lobby.header.logoutTips'),
      onCancel: async () => {
        try {
          await User.logout()
          modal.destroy()
        } catch (error) {
          console.error(error)
        }
      },
      cancelText: t('lobby.header.logoutOkText') as string,
      okText: t('lobby.header.logoutCancelText') as string
    })
  }
  /**
   *  普通登录/短信验证登录
   */
  @WithGeeGuard()
  public static async login(
    payload: NormalLoginFormData,
    headers?: GeeHeaders
  ) {
    const [error, loginResponse] = await to(apiLogin(payload, headers))
    if (error) return Promise.reject(error)
    //后台的二不登陆验证为了携带数据回来，code是=1 不会触发error，所以需要在这里特殊判断是二步验证
    if (
      loginResponse?.data?.code === GlobalConst.ServiceCode.SUCCESS &&
      loginResponse?.data?.data?.loginVerify
    ) {
      //登录二步验证
      await Modal.close('loginRegisterModal')
      await Modal.close('veriryBindPhone')
      Modal.open('loginAuthModal', {
        formData: payload,
        loginVerify: loginResponse?.data?.data?.loginVerify
      })
      return Promise.reject()
    }
    const userInfos = loginResponse?.data?.data
    if (userInfos && !userInfos.registrable) {
      this.handleLoginSuccess(userInfos, 'normal', payload.userpass)
      /**
       * 会员导入,没有手机号直接弹提示框
       */
      if (userInfos?.showPassword === CommonSwitchStatus.OPEN) {
        const verifyUserPasswordPayload = {
          username: payload.username,
          userpass: payload.userpass
        }

        GlobalManager.Modal.open(
          'verifyUserPassword',
          verifyUserPasswordPayload
        )
      }
    }
    return userInfos
  }

  @WithGeeGuard()
  public static async smsLogin(payload: SMSLoginReq, headers?: GeeHeaders) {
    const loginResponse = await apiSMSLogin(payload, headers)
    const userInfos = loginResponse?.data?.data
    if (userInfos) {
      this.handleLoginSuccess(userInfos, 'sms')
    }
  }

  /** 校验密码是否符合后台设置的复杂密码 */
  public static validatePassword(password: string): boolean {
    const {
      strongPasswdRequireUppercase,
      strongPasswdRequireLowercase,
      strongPasswdRequireNum,
      strongPasswdRequireSpecial,
      strongPasswdLength
    } = useMainStore()?.systemInfos as SystemInfos

    // 密码长度
    if (password.length < strongPasswdLength) {
      return false
    }
    // 是否包含数字
    if (strongPasswdRequireNum && !/\d/.test(password)) {
      return false
    }
    // 是否包含特殊符号
    if (strongPasswdRequireSpecial && !/[!@#$%^&*_=+-,./?]+/.test(password)) {
      return false
    }
    // 是否包含小写字母
    if (strongPasswdRequireLowercase && !/[a-z]/.test(password)) {
      return false
    }
    // 是否包含大写字母
    if (strongPasswdRequireUppercase && !/[A-Z]/.test(password)) {
      return false
    }
    return true
  }

  /**
   * @description 调用快速登录的接口也需要保留上一次的信息
   */
  private static updateUserinfoByCallFastLogin(userInfos: UserInfos) {
    const { updateUserInfos, userInfos: lastUserInfos } = useMainStore()
    // 获取上一次是否领取渠道彩金的数据
    const lastIsChannelPrize = lastUserInfos?.isChannelPrize ?? 0
    // 上一次从登录接口的返回是否登录过app或者h5的值
    const lastLoginOsType = lastUserInfos?.loginOsType ?? 0
    updateUserInfos(
      {
        ...userInfos,
        // 如果该设备之前已经领取过，那么就算换账号也是领取过
        isChannelPrize: lastIsChannelPrize,
        // 使用上一次的普通登录的是否登录过app的值
        loginOsType: lastLoginOsType
      },
      'fastlogin'
    )
  }

  /** 登录成功回调 */
  private static async handleLoginSuccess(
    userInfos: UserInfos,
    loginType: LoginType,
    userpass?: string
  ) {
    Modal.close('firstChargeConstant')
    const { updateUserInfos, systemInfos, updateBrowserFingerId } =
      useMainStore()
    const { loginPasswdStrengthDetectSwitch, strongPasswdWeakLoginRemind } =
      systemInfos as SystemInfos
    const { t } = useI18n()
    if (userInfos) {
      const score = checkPasswordStrength(userpass ?? '', userInfos.platfromid)
      // 登录成功后如果后台开启了提示并且用户密码为弱密码给出提示
      // 安全校验小于2时为弱密码
      if (
        userInfos.account_type === AccountType.Normal &&
        userInfos.userkey &&
        userpass &&
        loginPasswdStrengthDetectSwitch &&
        strongPasswdWeakLoginRemind &&
        score < 2
      ) {
        Modal.message({
          type: 'warning',
          content: t('lobby.modal.login.passwordHint')
        })
      }
      if (loginType === 'fastlogin') {
        this.updateUserinfoByCallFastLogin(userInfos)
      } else {
        updateUserInfos(userInfos, loginType)
        // 更新设备号
        updateBrowserFingerId(userInfos.deviceFingerprint)
      }
      this.logSend()
      if (loginType === 'fastlogin') {
        // 此处的登录,是刷新页面的登录,此时不能重置数据,不能备掉勾选状态
        useGameStore().getByTemplate()
        // useTaskModalStore().freshCodeCateReceive()
      }
      // 如果是快速登录(刷新页面的场景,不进行重置)
      else {
        useActivityChestStore().$reset()
        useFirstChargeConstantStore().myReset()
        useTaskModalConstant().myRest()
        useTaskPageStore().myReset()
      }

      // useGameStore().fetchPlatformExchangeList()
      // ws监听更新用户最新金额
      useMainStore().listenChangeGameGold()
    }
  }

  /**
   * 1.已经登录且开启了记住密码 刷新页面进行快速登录
   * 2. 注册成功后直接通过快速登录进行登录
   */
  public static async fastLogin(
    payload: { userkey: string; mtpush_id?: string },
    options: {
      retry?: boolean
      silentOnError?: boolean
      clearUserInfosOnError?: boolean
      isRetryMode?: boolean
    } = {
      /**
       * 是否开启重试
       */
      retry: true,
      silentOnError: false,
      /**
       * 失败时是否清理用户信息
       */
      clearUserInfosOnError: true,
      /**
       * 当次是否是重试
       */
      isRetryMode: false
    }
  ) {
    const {
      retry = true,
      silentOnError = false,
      isRetryMode = false,
      clearUserInfosOnError = true
    } = options
    const { updateUserInfos } = useMainStore()
    //
    const [error, loginResponse] = await to(
      apiFastLogin(payload, silentOnError || !isRetryMode)
    )
    if (error) {
      /**
       * 如果没开启重试模式 或者 开启了重试模式但该次请求为重试请求
       */
      if (!retry || isRetryMode) {
        if (clearUserInfosOnError) {
          updateUserInfos(null)
        }
        return Promise.reject(error)
      } else {
        await this.fastLogin(payload, {
          ...options,
          isRetryMode: true
        })
      }
    }

    const userInfos = loginResponse?.data?.data
    if (userInfos) {
      this.handleLoginSuccess(userInfos, 'fastlogin')
    }
  }

  public static mockTryModeUserInfo(
    config: { tryCurrency?: CurrencyInfos } = {}
  ) {
    const { updateUserInfos, currentTryCurrency } = useMainStore()

    const userInfos = {
      session_key: process.env.SITE_STATIC_TOKEN,
      game_gold: 2000,
      account_type: 1,
      platfromid: 'web_lobby_guest_account',
      mode: 0,
      currency:
        config?.tryCurrency?.currencyCode ||
        currentTryCurrency?.currencyCode ||
        ''
    }
    updateUserInfos(userInfos as UserInfos, 'trymode')
  }
  /**
   * 可能直接登录成功，可能未注册就引导注册
   */
  @WithGeeGuard()
  public static async thirdWayLogin(
    payload: ThirdWayLoginReq,
    headers?: GeeHeaders
  ) {
    const { updateUserInfos } = useMainStore()
    const loginResponse = await apiThirdWayLogin(payload, headers)
    const userInfos = loginResponse?.data?.data
    /**
     * code 为 100 时 说明是 新账号 需要引导修改账号密码
     */
    if (userInfos) {
      if ((userInfos as ThirdWayLoginNewAccountRes).code !== 100) {
        updateUserInfos(userInfos as UserInfos, 'thirdlogin')
        // useTaskModalStore()
        //   .myReset()
        //   .then(() => {
        //     useTaskModalStore().freshCodeCateReceive()
        //   })
        useActivityChestStore().$reset()
        useTaskPageStore().myReset()
        useFirstChargeConstantStore().myReset()
        useTaskModalConstant().myRest()
        this.logSend()
      } else {
        return userInfos as ThirdWayLoginNewAccountRes
      }
    }
  }
  /**
   *  三方注册并自动登录
   */
  @WithGeeGuard()
  public static async thirdWayRegister(
    payload: ThirdWayLoginReq,
    headers?: GeeHeaders
  ) {
    const { updateUserInfos } = useMainStore()
    const registerResponse = await apiThirdWayRegister(payload, headers)
    const userInfos = registerResponse?.data?.data
    if (userInfos) {
      updateUserInfos(userInfos, 'thirdlogin')
      // useTaskModalStore()
      //   .myReset()
      //   .then(() => {
      //     useTaskModalStore().freshCodeCateReceive()
      //   })
      useActivityChestStore().$reset()
      useTaskPageStore().myReset()
      useFirstChargeConstantStore().myReset()
      useTaskModalConstant().myRest()
      this.logSend()
    }
  }

  /**
   * 更新货币信息
   * minRequestTime为至少的请求时长
   */
  public static async updatePrize(minRequestTime = 0) {
    const { updateUserInfos } = useMainStore()
    const [prizeResponse] = await Promise.all([
      apiGetHomeGold(),
      delay(minRequestTime)
    ])
    updateUserInfos(
      merge({}, useMainStore().userInfos, {
        game_gold: prizeResponse.data.data?.game_gold
      })
    )
  }

  /**
   *  普通注册
   */
  @WithGeeGuard()
  public static async register(
    payload: NormalRegisterRequest,
    headers?: GeeHeaders
  ) {
    const registerResponse = await apiRegister(payload, headers)
    const userkey = registerResponse.data.data?.userkey
    if (userkey) {
      await this.fastLogin({ userkey }).catch(() => {
        /**
         */
      })
    }
  }

  /**
   * @deprecated 废弃（新接入业务使用GeeTest.checkGeetestRestricted）
   */
  public static checkGeetestRestricted(duration = 60) {
    const { geetestRestrictedTime } = useMainStore()
    const { t } = useI18n()
    const diff = GlobalManager.Site.getTime() - geetestRestrictedTime
    const restricted = diff <= duration
    if (restricted) {
      //操作频繁，请xx秒后再试
      GlobalManager.Modal.message({
        type: 'error',
        content: t('lobby.common.errorMessages.GEETEST_RESTRICTED', {
          seconds: duration - diff
        }) as string
      })
    }
    return restricted
  }

  /**
   * 初始化注册极验三方验证
   * @deprecated 废弃（新接入业务使用GeeTest.initGeetest）
   */
  public static async initGeetest(
    options: {
      domId?: string
      geetestConfig: {
        captchaId: string
        product?: string
        hideBar?: boolean
        language?: string
        nextWidth?: string
      }
    } = { geetestConfig: { captchaId: '' } }
  ) {
    const { language, $patch } = useMainStore()
    const { t } = useI18n()
    options = merge(
      {
        domId: 'geetest',
        geetestConfig: {
          product: 'bind', // 极验验证弹窗方式
          hideBar: false // 默认打开关闭按钮
        }
      },
      options
    )
    /** geetest极验加载bug, 先初始化bind后，再初始化popup就会渲染报错，目前解决方案是删除initGeetest4对象,和对应js文件，重新加载一次geetest库 */
    if (options.geetestConfig.product === 'popup' && window.initGeetest4) {
      delete window.initGeetest4
    }
    const callRegister = async () => {
      return new Promise<TGeetestCaptchaResult>((resolve, reject) => {
        try {
          const config = merge(
            {
              product: 'bind', // 极验验证弹窗方式
              language: ((lang: Language) => {
                const lan = GlobalConst.GeetestLanguageMap[lang]
                if (lan === 'none') {
                }
                return lan
              })(language),
              onError: (err: { desc: string; msg: string; code: number }) => {
                GlobalManager.Modal.message({
                  type: 'error',
                  content: () =>
                    `${t(
                      'lobby.common.components.geetest.error'
                    )}${JSON.stringify(
                      (() => {
                        try {
                          return pick(err, ['code', 'lot_number'])
                        } catch (error) {
                          return {}
                        }
                      })()
                    )}`
                })
                reject(err)
              },
              getType: {
                apiServers: Const.GeetestApiServers
              }
            },
            options.geetestConfig
          )
          window?.initGeetest4 && window.initGeetest4(config, resolve)
        } catch (error) {
          GlobalManager.Modal.message({
            type: 'error',
            content: () => t('lobby.common.components.geetest.error')
          })
          reject(error)
        }
      })
    }
    const callRenderToBody = async ({
      geetestInstance
    }: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      geetestInstance: any
    }) => {
      if (document.querySelector(`#${options.domId}`)) {
        geetestInstance.appendTo(`#${options.domId}`)
        return
      }
      const geetestDom = document.createElement('div')
      geetestDom.setAttribute('id', options.domId as string)
      document.body.append(geetestDom)
      geetestInstance.appendTo(`#${options.domId}`) //将验证按钮插入到宿主页面中captchaBox元素内
    }
    // 加载gt库
    if (!window.initGeetest4) {
      await loadScripts(
        [
          {
            id: 'gt',
            src: '/libs/gt@4.1.1/gt.js'
          }
        ],
        false,
        false
      )
    }

    // 从服务器获取geetest配置参数

    const captchaObj = await callRegister()
    callRenderToBody({
      geetestInstance: captchaObj
    })

    captchaObj
      .onReady(() => {
        captchaObj.showCaptcha()
      })
      .onError((errorInfo) => {
        // error_12 拼图拼不上达到5次以上 error_01 刷新达到5次以上
        if (
          errorInfo.error_code == 'error_12' ||
          errorInfo.error_code == 'error_01'
        ) {
          const time = GlobalManager.Site.getTime()
          $patch({
            geetestRestrictedTime: time
          })
          GlobalManager.User.checkGeetestRestricted()
        } else {
          GlobalManager.Modal.message({
            type: 'error',
            content: () =>
              `${t('lobby.common.components.geetest.error')}${JSON.stringify(
                (() => {
                  try {
                    return pick(errorInfo, ['code', 'lot_number'])
                  } catch (error) {
                    return {}
                  }
                })()
              )}`
          })
        }
      })
    return captchaObj
  }
  /**
   * 服务端校验极验数据
   * @deprecated 废弃（新接入业务使用GeeTest.validateGeetest）
   */
  public static async validateGeetest(payload: GeetestValidate) {
    const { hasLogined } = useMainStore()
    return hasLogined
      ? apiLoginAfterGeetestValidate(payload)
      : apiLoginBeforeGeetestValidate(payload)
  }
}
